export function returnError(error) {
    console.log("ERRORE DI AXIOS");
    if (error.response?.status === 404) {
        return error.response?.data;
    }
    throw error;
}